export const UPDATE_PHONE_SEND_OTP_LOADING = "UPDATE_PHONE_SEND_OTP_LOADING";
export const UPDATE_PHONE_SEND_OTP_SUCCESS = "UPDATE_PHONE_SEND_OTP_SUCCESS";
export const UPDATE_PHONE_SEND_OTP_FAILURE = "UPDATE_PHONE_SEND_OTP_FAILURE";

export const UPDATE_PHONE_VERIFY_OTP_LOADING =
  "UPDATE_PHONE_VERIFY_OTP_LOADING";
export const UPDATE_PHONE_VERIFY_OTP_SUCCESS =
  "UPDATE_PHONE_VERIFY_OTP_SUCCESS";
export const UPDATE_PHONE_VERIFY_OTP_FAILURE =
  "UPDATE_PHONE_VERIFY_OTP_FAILURE";

export const DEACTIVATE_SEND_OTP_LOADING = "DEACTIVATE_SEND_OTP_LOADING";
export const DEACTIVATE_SEND_OTP_SUCCESS = "DEACTIVATE_SEND_OTP_SUCCESS";
export const DEACTIVATE_SEND_OTP_FAILURE = "DEACTIVATE_SEND_OTP_FAILURE";

export const DEACTIVATE_VERIFY_OTP_LOADING = "DEACTIVATE_VERIFY_OTP_LOADING";
export const DEACTIVATE_VERIFY_OTP_SUCCESS = "DEACTIVATE_VERIFY_OTP_SUCCESS";
export const DEACTIVATE_VERIFY_OTP_FAILURE = "DEACTIVATE_VERIFY_OTP_FAILURE";

export const JOB_POST_ELIGIBILITY_SUCCESS = "JOB_POST_ELIGIBILITY_SUCCESS";

export const JOB_POST_ELIGIBILITY_FAILURE = "JOB_POST_ELIGIBILITY_FAILURE";

export const IS_COMP_NAME_FROM_SUGGESTOR = "IS_COMP_NAME_FROM_SUGGESTOR";
